import { UserRoleKey } from '../types';
import { ROLE_DISPLAY_NAMES } from '../constants/roles';

export const resolveEffectiveValue = (
  override: boolean | null,
  defaultValue: boolean,
): boolean => {
  if (override !== null) return override;
  return defaultValue;
};

export const getRoleDisplayName = (roleKey: UserRoleKey): string => {
  return ROLE_DISPLAY_NAMES[roleKey] || roleKey;
};

export const FIELD_PERMISSION_LABELS: Record<string, string> = {
  canView: "צפייה",
  isRequiredOverride: "חובה",
  isEditableOverride: "ניתן לעריכה",
};
